import { useEffect, useState } from 'react';
import { randomColorGenerator } from 'src/utils/randomColorGenerator';

type Props = {
  name?: string;
  photo?: string;
};

export const UserAvatar = ({ name = 'Unknown', photo }: Props) => {
  const [showPhoto, setShowPhoto] = useState<boolean>(false);
  const [lightColor] = randomColorGenerator(name);

  useEffect(() => {
    if (photo) {
      setShowPhoto(true);
    }
  }, [photo]);

  return (
    <div className='flex h-8 w-8 items-center justify-center overflow-hidden rounded-full'>
      {showPhoto ? (
        <img
          src={photo}
          alt='User'
          loading='lazy'
          // className='h-8 w-8 rounded-full'
          onError={() => setShowPhoto(false)}
        />
      ) : (
        <div
          style={{ backgroundColor: lightColor }}
          className='flex h-full w-full items-center justify-center'
        >
          <span className='heading-100'>{name.charAt(0)}</span>
        </div>
      )}
    </div>
  );
};
